import React from 'react'
import Searchweather from './components/Searchweather'
import './App.css'


export default function App() {

  return (
    <div>
      <h1 style={{
        textAlign: "center"
      }}>WeatherApp</h1>
      < Searchweather />
    </div>
  )
}
